import React, { useState } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import {
  _PhotosAndLocationMenu,
  _MenuList,
  _MenuItem,
  _Slider,
  _Label,
} from './styles'

export const photoLocationMenus = {
  photos: 'Photos',
  location: 'Map',
  streetView: 'Street View',
}

const PhotosAndLocationMenu = ({ selectedMenu, onMenuSelect, showPhotos, winWidth }) => {
  const [isMenuOpen, toggleMenu] = useState(false)
  const [activeTab, setActiveTab] = useState(selectedMenu)
  let newMenuOptions = photoLocationMenus
  if(!showPhotos) {
    newMenuOptions = R.dissoc('photos', { ...newMenuOptions })
  }
  return (
    <_PhotosAndLocationMenu winWidth={winWidth}>
      <_MenuList isMenuOpen={isMenuOpen}>
        {
          Object.keys(newMenuOptions).map((key, index) =>
            (
              <_MenuItem
                id={index}
                key={key}
                onClick={
                    () => {
                      onMenuSelect(key)
                      toggleMenu(false)
                      setActiveTab(key)
                    }
                  }
              >
                {
                    activeTab === key &&
                  (
                    <_Slider
                      layoutId={'sliding'}
                      // transition={{ layout: {duration: 0.6} }}
                    />
                  )
                  }
                <_Label isActive={activeTab === key}>{newMenuOptions[key]}</_Label>
              </_MenuItem>
            ))
        }
      </_MenuList>
    </_PhotosAndLocationMenu>
  )
}

PhotosAndLocationMenu.propTypes = {
  selectedMenu: PropTypes.string,
  onMenuSelect: PropTypes.func,
  showPhotos: PropTypes.bool,
  winWidth: PropTypes.number,
}

export default PhotosAndLocationMenu
